module.exports = __webpack_public_path__ + "static/media/Wired_Reconfiguration.600e4f33.mp3";